import React from 'react';
import {
  AiAssistantIcon,
  DateRangeIcon,
  DeleteIcon,
  DownloadIcon,
  EditIcon,
  ExpandAltIcon,
  FilterIcon,
  LockIcon,
} from '../Icons';

export function buildTileActionMenuOptions({
  editNameLabel,
  resizeLabel,
  editDateRangeLabel,
  lockLabel,
  askAiLabel,
  deleteLabel,
}) {
  return [
    { value: 'edit', label: editNameLabel, icon: <EditIcon size={16} /> },
    { value: 'resize', label: resizeLabel, icon: <ExpandAltIcon size={16} /> },
    { value: 'dates', label: editDateRangeLabel, icon: <DateRangeIcon size={16} /> },
    { value: 'lock', label: lockLabel, icon: <LockIcon size={16} /> },
    { value: 'ai', label: askAiLabel, icon: <AiAssistantIcon size={16} aria-hidden /> },
    { value: 'delete', label: deleteLabel, icon: <DeleteIcon size={16} /> },
  ];
}

/** Shared class for `Dropdown.ActionMenu` on dashboard table/chart card toolbars. */
export const TILE_TOOLBAR_ACTION_MENU_CLASS = 'ds-tile-toolbar__action-menu';

/** Ellipsis trigger for tile / card toolbar More menus. */
export const TILE_ACTION_MENU_MORE_ICON = (
  <span
    aria-hidden
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 2,
      width: 18,
      height: 18,
    }}
  >
    {[0, 1, 2].map((i) => (
      <span
        key={i}
        style={{
          width: 3,
          height: 3,
          borderRadius: 999,
          background: 'currentColor',
        }}
      />
    ))}
  </span>
);

export function buildTileToolbarHeaderActions({
  filterLabel,
  downloadLabel,
  moreLabel,
  onFilterClick,
  onDownloadClick,
  menuOptions,
  onMenuChange,
  iconClassName = 'ds-tile-toolbar__icon',
  actionMenuClassName = TILE_TOOLBAR_ACTION_MENU_CLASS,
  includeDownload = true,
  includeFilter = true,
  idPrefix,
}) {
  const actions = [];

  if (includeFilter && onFilterClick) {
    actions.push({
      type: 'button',
      id: 'filter',
      domId: idPrefix ? `${idPrefix}-filter-btn` : undefined,
      icon: <FilterIcon className={iconClassName} size={18} />,
      ariaLabel: filterLabel,
      onClick: onFilterClick,
    });
  }

  if (includeDownload && onDownloadClick) {
    actions.push({
      type: 'button',
      id: 'download',
      domId: idPrefix ? `${idPrefix}-download-btn` : undefined,
      icon: <DownloadIcon className={iconClassName} size={18} />,
      ariaLabel: downloadLabel,
      onClick: onDownloadClick,
    });
  }

  if (Array.isArray(menuOptions) && menuOptions.length > 0 && onMenuChange) {
    actions.push({
      type: 'dropdown',
      id: 'more',
      domId: idPrefix ? `${idPrefix}-overflow` : undefined,
      className: actionMenuClassName,
      triggerIcon: TILE_ACTION_MENU_MORE_ICON,
      ariaLabel: moreLabel,
      options: menuOptions,
      onChange: onMenuChange,
      align: 'right',
    });
  }

  return actions;
}
